import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPaypalError } from 'State/Checkout/CheckoutActions';
import { PayPalButton } from 'Components/PayPal/PayPalButton';
import { PAYMENT_METHODS } from 'Features/PaymentMethodSelector/PaymentMethodSelector';
import { showOverlay } from 'State/Layouts/LayoutActions';
import { usePayPal } from 'Hooks/usePayPal';

export const PayPalSelector = ({ handlePayment, submitButtonText, idName }) => {
  const dispatch = useDispatch();
  const { hasPaypalPayment } = useSelector((s) => s.paymentMethods);
  const [isPayPalEnabled, paypalActions] = usePayPal();

  if (!isPayPalEnabled) {
    return null;
  }
  // For saved payments we do not want to render another button so return null
  return (
    <Fragment>
      {hasPaypalPayment ? null : (
        <div className="paypalPaymentMethod">
          <PayPalButton
            submitButtonText={submitButtonText}
            onClick={() => paypalActions.createSubscriptionOrder()}
            idName={idName}
            onApprove={(data) => {
              dispatch(showOverlay('', true));
              return handlePayment('paypal', data, PAYMENT_METHODS.PAYPAL);
            }}
            onError={(error) => dispatch(setPaypalError(error.message))}
          />
        </div>
      )}
    </Fragment>
  );
};
